export const getRouteParams = (url: string) => {
  // * Remove hash from url
  const serializedUrl = url.replaceAll("#", "");

  return Object.fromEntries(
    new URL(serializedUrl).searchParams.entries()
  );
};